module.exports = __webpack_public_path__ + "img/authForteKo57.473ef976.png";